<template>
  <main id="admin-content">
    <Header :collapsed="false"></Header>
    <div class="body-content sessions-container">
      <div class="page-controls">
        <div class="page-controls__action-row">
          <button class="page-controls__primary-action button secondary short" id="page-add-course-button"
                  v-b-toggle.sidebar-no-header="'sidebar-new'">
            <span>Crear usuario</span>
          </button>
          <EditUserSidebar
            :user="new_user"
            @refresh="getUsers">
          </EditUserSidebar>
        </div>
        <div class="page-controls__control-row">
          <div class="page-controls__filter" style="display: flex;">
            <div
              class="dropdown-filter select-wrapper" style="margin-left: auto;"
            >
              <span class="dropdown-filter__select-label">Por página</span>
              <b-form-select v-on:change="resetPagination" plain class="limit-selector" v-model="users_pagination.limit" :options="users_pagination_options"></b-form-select>
              <span class="dropdown-filter__select-label">Filtrar por</span>
              <b-dropdown id="dropdown-right" right :text="selected_filter" variant=" dropdown-filter__select button button-select dropdown">
                <b-dropdown-item @click="allTypes()">Todas los tipos</b-dropdown-item>
                <b-dropdown-item @click="studentType()">Estudiante</b-dropdown-item>
                <b-dropdown-item @click="staffType()">Staff</b-dropdown-item>
              </b-dropdown>
              <div class="d-flex align-items-center">
                <span class="dropdown-filter__select-label mr-2">Nombre</span>
                <input type="text"
                        placeholder="Mínimo 3 caracteres" class="m-0 mr-2"
                        v-model="filter_name">
              </div>
              <div class="d-flex align-items-center">
                <span class="dropdown-filter__select-label mr-2">Correo electrónico</span>
                <input type="text"
                        placeholder="Mínimo 3 caracteres" class="m-0 mr-2"
                        v-model="filter_email">
              </div>
              <div class="d-flex align-items-center">
                <span class="dropdown-filter__select-label mr-2">ID Proeduca</span>
                <input type="text"
                        placeholder="Mínimo 3 caracteres" class="m-0 mr-2"
                        v-model="filter_unirid">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full-width-content--small" v-show="!loading">
        <div v-if="!users.length" class="no-content no-results">
          <span class="no-content-title">No encontramos usuarios que coincidan con esos criterios.</span>
        </div>
        <table v-else class="content-table">
          <tbody>
          <tr class="content-table__header content-table__header--shadow">
            <th class="medium-4">Nombre</th>
            <th class="medium-4">Apellidos</th>
            <th class="medium-8">Correo electrónico</th>
            <th class="medium-4">Tipo</th>
            <th class="medium-4">ID Proeduca</th>
          </tr>
          <tr v-for="user in users" v-bind:key="user.id" class="element-list-row">
            <td class="break-word content-table__emphasis">
              {{ user.givenName }}
              <EditUserSidebar
                :user="user"
                @refresh="getUsers">
              </EditUserSidebar>
            </td>
            <td class="break-word content-table__emphasis">
              {{ user.lastName }}
            </td>
            <td class="break-word content-table__emphasis">
              {{ user.contactEmail }}
            </td>
            <td class="break-word content-table__emphasis">
              <span style="display: block;" v-if="isStaff(user)">Staff</span>
              <span style="display: block;" v-if="!isStaff(user)">Estudiante</span>
            </td>
            <td class="break-word content-table__emphasis">
              {{ user.unirId }}
            </td>
            <td class="item-controls">
              <b-dropdown right menu-class="button-list-icons small-icons"
                          variant=" icon-button session-row-options list-item-icon has-tooltip"
                          toggle-class="text-decoration-none" no-caret>
                <template :id="'user-options-' + user.id" #button-content>
                  <dots-horizontal-circle-outline-icon :size="20"/>
                  <b-tooltip :target="'user-options-' + user.id" triggers="hover">
                    Opciones del usuario
                  </b-tooltip>
                </template>
                <b-dropdown-item-btn link-class="button" v-b-toggle.sidebar-no-header="'sidebar-edit-' + user.id">
                  <pencil-outline-icon class="svg-icon small default" :size="20"/>
                  <span>Editar configuración</span>
                </b-dropdown-item-btn>
              </b-dropdown>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <footer v-if="users_pagination.limit < users_total" class="page-footer session-list-pagination">
      <b-pagination
        v-model="users_pagination_current"
        :total-rows="users_total"
        :per-page="users_pagination.limit"
        align="center"
        aria-controls="report-content-table"
      ></b-pagination>
    </footer>
    <vue-confirm-dialog class="pv-confirm"></vue-confirm-dialog>
  </main>
</template>

<script>
import DotsHorizontalCircleOutlineIcon from 'vue-material-design-icons/DotsHorizontalCircleOutline.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
import LoginIcon from 'vue-material-design-icons/Login.vue'
import TextBoxSearchOutlineIcon from 'vue-material-design-icons/TextBoxSearchOutline.vue'
import PencilOutlineIcon from 'vue-material-design-icons/PencilOutline.vue'
import VideoOutlineIcon from 'vue-material-design-icons/VideoOutline.vue'
import jwtMixin from '../../mixins/jwtMixin'
import utilitiesMixin from '../../mixins/utilitiesMixin'
import EditClassroomSidebar from '../Lti/SessionsModals/EditClassroomSidebar'
import EditUserSidebar from './Modals/EditUserSidebar'

import Header from '@/components/Admin/Header/Header'

export default {
  name: 'UsersAdmin',
  components: {Header, DotsHorizontalCircleOutlineIcon, LocationEnterIcon, MagnifyIcon, LoginIcon, TextBoxSearchOutlineIcon, PencilOutlineIcon, EditClassroomSidebar, VideoOutlineIcon, EditUserSidebar},
  mixins: [jwtMixin, utilitiesMixin],
  created () {
    this.initUsers()
  },
  data () {
    return {
      loading: false,
      user_groups: [],
      user_roles: [],
      users: [],
      users_total: 0,
      users_pagination_current: 1,
      users_pagination: {
        limit: this.defaultPagination(),
        offset: 0
      },
      new_user: {
        id: '',
        givenName: null,
        lastName: null,
        zoomId: null,
        createZoomAccount: false,
        unirId: null,
        unirType: 'P'
      },
      users_pagination_options: this.paginationOptions(),
      selected_filter: 'Todas los tipos',
      filter_name: null,
      filter_email: null,
      filter_unirid: null
    }
  },
  watch: {
    users_pagination_current: {
      handler: function (value) {
        // CMM: se establece la paginación acorde a la página activada
        this.users_pagination.offset = this.users_pagination.limit * (this.users_pagination_current - 1)
        this.getUsers()
      }
    },
    filter_name: function (value) {
      this.handleSearch(value, this.filter_email, this.filter_unirid)
    },
    filter_email: function (value) {
      this.handleSearch(value, this.filter_name, this.filter_unirid)
    },
    filter_unirid: function (value) {
      this.handleSearch(value, this.filter_email, this.filter_name)
    }
  },
  methods: {
    initUsers () {
      this.loading = true

      // CMM: Por defecto en la entrada se cargan los próximos usuarios
      this.allTypes()
    },
    getUsers () {
      let vueComponent = this
      this.users = []
      this.users_total = 0
      let filterParams = {
        limit: this.users_pagination.limit,
        offset: this.users_pagination.offset
      }
      // CMM: Configuración de filtros
      if (this.filter_name && this.filter_name.length >= 3) {
        filterParams.firstName = this.filter_name
      }
      if (this.filter_email && this.filter_email.length >= 3) {
        filterParams.email = this.filter_email
      }
      if (this.filter_unirid && this.filter_unirid.length >= 3) {
        filterParams.unirId = this.filter_unirid
      }

      if (this.selected_filter !== 'Todas los tipos') {
        if (this.selected_filter === 'Estudiante') {
          filterParams.unirType = 'S'
        } else if (this.selected_filter === 'Staff') {
          filterParams.unirType = 'P'
        }
      }

      window.axios.get('users/', {params: filterParams}).then((response) => {
        // CMM: Se recupera la información de los usuarios
        vueComponent.users = []
        this.users_total = response.data.size
        response.data.results.forEach(function (user) {
          vueComponent.users.push(user)
        })
        this.loading = false
      })
    },
    resetPagination () {
      // CMM: Si no estaba en la página inicial se cambia a la primera. El cambio lanza la recarga del listado
      if (this.users_pagination_current !== 1) {
        this.users_pagination_current = 1
      } else {
        this.getUsers()
      }
    },
    allTypes () {
      this.selected_filter = 'Todos los tipos'
      this.resetPagination()
    },
    studentType () {
      this.selected_filter = 'Estudiante'
      this.resetPagination()
    },
    staffType () {
      this.selected_filter = 'Staff'
      this.resetPagination()
    },
    handleSearch (value, filterToCheck1, filterToCheck2) {
      if (value && value.length >= 3) {
        this.resetPagination()
      } else if ((filterToCheck1 && filterToCheck1.length >= 3) || (filterToCheck2 && filterToCheck2.length >= 3)) {
        this.resetPagination()
      } else {
        this.resetPagination()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/UsersAdmin.vue